import graphql from 'babel-plugin-relay/macro';
import { fetchQuery } from 'relay-runtime';
import { environment } from '../../Environment';

const query = graphql`
  query BooksQuery(
    $first: Int
    $after: String
    $filter: BookFilterAttributes
    $sort: SortAttributes
  ) {
    books(
      first: $first
      after: $after
      filter: $filter
      sort: $sort
    ) {
      edges {
        node {
          id
          dbId
          title
          genre
          imageUrl
          visibility
          isbn
          description
          publicationYear
          authors {
            id
            dbId
            name
          }
          publisher {
            id
            dbId
            name
          }
          entities {
            id
            dbId
            availability
            sku
            entityStates {
              id
              dbId
              state
              dueDate
              userId
            }
          }
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`;

const fetch = params => fetchQuery(environment, query, params).toPromise();

export default { fetch };
